__turbopack_context__.v({
  "outOfStockAlert": "ProductNotInStockSection-module-scss-module__JZfOPW__outOfStockAlert",
  "outOfStockButton": "ProductNotInStockSection-module-scss-module__JZfOPW__outOfStockButton",
  "outOfStockRecommendations": "ProductNotInStockSection-module-scss-module__JZfOPW__outOfStockRecommendations",
  "stockMessage": "ProductNotInStockSection-module-scss-module__JZfOPW__stockMessage",
});
